// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GW3k","importantInfo":"styles_importantInfo__cAIdu"};